import { SEARCH_SEARCH_BOOKS_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  bookList: null,
  booksCount: null,
  query: null,
  pageNumber: 1,
  lastPageNumber: 1,
  isLoading: true,
};

export default function searchBooks(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_BOOKS_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
